import { Button } from "@/components/design-system/Button";
import { ButtonBar } from "@/overlay/components/CommonParts/buttons";
import { Modal } from "@/overlay/components/window/Modal";
import { t } from "@lingui/core/macro";
import styles from "./Modal.module.scss";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string; // Optional, in case you want to display item name
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.container}>
        <h2>{t`Confirm Deletion`}</h2>
        <p>
          {itemName ? t`Are you sure you want to delete "${itemName}"?` : t`Are you sure you want to delete this item?`}
        </p>
        <div className={styles.buttonGroup}>
          <ButtonBar>
            <Button variant="secondary" data-testid="confirmation-cancel" onClick={() => onClose()}>
              {t`Cancel`}
            </Button>

            <Button variant="danger" data-testid="confirmation-yes" onClick={() => onConfirm()}>
              {t`Delete`}
            </Button>
          </ButtonBar>
        </div>
      </div>
    </Modal>
  );
};
